// extracted by mini-css-extract-plugin
export default {"smallScreenSidebar":"thememaker_smallScreenSidebar__+6AlL","bigScreenSidebar":"thememaker_bigScreenSidebar__FScOe"};